<template>
  <div class="input">
    <div class="input-label">開催日</div>

    <div class="input-group">
      <input
        type="number"
        :min="$store.getters['event/minYear']"
        class="input-text"
        v-model="year">
      <div class="input-label_after">年</div>

      <input
        type="number"
        min="1"
        max="12"
        class="input-text"
        v-model="month">
      <div class="input-label_after">月</div>

      <input
        type="number"
        min="1"
        max="31"
        class="input-text"
        v-model="day">
      <div class="input-label_after">日</div>
    </div>
  </div>


</template>

<script>
export default {
  computed: {
    year: {
      get: function () {
        return this.$store.state.event.year
      },
      set: function (value) {
        this.$store.commit(
          'event/setYear',
          value
        )
      }
    },

    month: {
      get: function () {
        return this.$store.state.event.month
      },
      set: function (value) {
        this.$store.commit(
          'event/setMonth',
          value
        )
      }
    },

    day: {
      get: function () {
        return this.$store.state.event.day
      },
      set: function (value) {
        this.$store.commit(
          'event/setDay',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
